import { Component, OnInit } from "@angular/core";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Dossier } from "src/app/suivi-portefeuille/core/model/dossier";
import { DossierService } from "src/app/suivi-portefeuille/core/service/dossier.service";
import { DossierProvision } from "src/app/suivi-portefeuille/core/model/DossierProvision";
import { GarantieModel } from "src/app/core/models/garantie-model";
@Component({
  selector: "app-detail-provision",
  templateUrl: "./detail-provision.component.html",
  styleUrls: ["./detail-provision.component.scss"],
})
export class DetailProvisionComponent implements OnInit {
  dossier: Dossier;
  etatProvisionCreances: any[];
  currentEtatCreance: any;
  dossierProvision: DossierProvision = new DossierProvision();
  garanties: GarantieModel[];
  numDossier: number;

  constructor(
    private _dossierService: DossierService,
    public activeModal: NgbActiveModal
  ) {}

  ngOnInit() {
    this.getDossierByNumDossier(this.numDossier);
    this.getDossierProvision(this.numDossier);
  }

  getDossierByNumDossier(numDossier) {
    this._dossierService
      .getDossierByNumDossier(numDossier)
      .subscribe((data) => {
        this.dossier = data;
      });
  }

  getDossierProvision(numDossier) {
    this._dossierService.getDossierProvision(numDossier).subscribe((data) => {
      if (data) {
        this.dossierProvision = data;
        if (data.etatProvisionCreances) {
          this.etatProvisionCreances = data.etatProvisionCreances;
        }
        if (data.garanties) {
          this.garanties = data.garanties;
        }
        if (data.currentEtatCreance) {
          this.currentEtatCreance = data.currentEtatCreance;
        }
      }
    });
  }
}
